import React from 'react'

const lineWrapStyle = {
  display: 'flex',
  alignItems: 'center'
}

const lineStyle = {
  border: '0.5px solid',
}

const Line: React.FC<{
  height?: string | number,
  color?: string
}> = ({
  height = '300px',
  color = '#E3E3E3',
}) => {
  return (
    <div style={{...lineWrapStyle}}>
      <div style={{...lineStyle, height, color}}></div>
    </div>
  )
}

export default Line;